import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AddressForm from '../features/AddressForm';
import * as routes from '../constants/routes';
import { Redirect } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Logo from '../assets/LIREX-logo.png';
import { withRouter } from 'react-router';
import { AppContext } from '../context/applicationContext';
import * as db from '../db/db';


const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(1) * 2,
    marginRight: theme.spacing(1) * 2,
    [theme.breakpoints.up(800 + theme.spacing(1) * 2 * 2)]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(1) * 3,
    marginBottom: theme.spacing(1) * 3,
    padding: theme.spacing(1) * 2,
    [theme.breakpoints.up(800 + theme.spacing(1) * 3 * 2)]: {
      marginTop: theme.spacing(1) * 6,
      marginBottom: theme.spacing(1) * 6,
      padding: theme.spacing(1) * 3,
    },
  },
  stepper: {
    padding: `${theme.spacing(1) * 3}px 0 ${theme.spacing(1) * 5}px`,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(0),
    width: '100%',
    color: 'white',
    backgroundColor: '#3a3f4b!important',
    justifyContent: 'center'
},
});

//const steps = ['Shipping address', 'Payment details', 'Review your order'];

class HolidaysConfirmForm extends React.Component {
  static contextType = AppContext;
  constructor(props){
    super(props);
    this.state={redirect:false}
  }
  logOut = () => {
    this.context.setStateCustom( 'userId', null);
    db.idbMethods.clear(db.userInfo);
    db.idbMethods.clear(db.holidaysForApprove);
    db.idbMethods.clear(db.holidaysForApproveList);
    db.idbMethods.clear(db.myHolidays);
    this.setState({ redirect: true });
}
  render() {
    const { classes } = this.props;
    //const { activeStep } = this.state;
    if (this.state.redirect) {
      return <Redirect to={routes.HOME_LOGIN} />
    }
    return (
      <React.Fragment>
        <CssBaseline />
        {/* <AppBar position="absolute" color="default" className={classes.appBar}>
          <Toolbar>
            <Grid container justify="flex-end" spacing={10}>
              <Grid item xs={6}>
                <Typography variant="h6" color="inherit" noWrap>
                <img className="img-logo" src={Logo}/>
                </Typography>
              </Grid>
              <Grid item align="right" xs={6}>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => { this.logOut() }}
                  className={classes.button+' backgraound-transperent'}
                  >
                      <ExitToApp className='green-circle'></ExitToApp>
                      Изход
                        </Button>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar> */}
        <main className={classes.layout + ' header-mrg'}>
          <Paper className={classes.paper}>
            <Typography component="h6" variant="h6" align="center">
              {this.state.holidayType ? 'Добавяне на болничен' : 'Добавяне на отпуск'}
            </Typography>
            <React.Fragment>
              <React.Fragment>
                {/* {getStepContent(activeStep)}                   */}
                <AddressForm handleTypeChange={(e) => this.handleTypeChange(e)} />
              </React.Fragment>

            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

HolidaysConfirmForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(HolidaysConfirmForm));